import React from 'react';
import { Reveal } from './Reveal';
export function BonusSection() {
  return <section className="py-14 px-6" data-id="element-45">
      <Reveal data-id="element-46">
        <span className="inline-block text-[10px] font-semibold tracking-[0.14em] uppercase text-sage mb-3" data-id="element-47">
          También incluido
        </span>
        <h2 className="font-serif text-[34px] font-semibold leading-[1.15] text-ink mb-2" data-id="element-48">
          Guía de
          <br data-id="element-49" />
          <em className="italic text-terra" data-id="element-50">Suplementos</em>
        </h2>
        <p className="text-[15px] leading-[1.7] text-ink-soft mb-7" data-id="element-51">
          No todos los suplementos que se venden para "hormonas" tienen respaldo
          científico. Esta guía separa lo que funciona de lo que no.
        </p>

        <div className="bg-terra-light border border-terra/20 rounded-2xl p-6 mt-6" data-id="element-52">
          <span className="inline-block bg-terra text-white text-[10px] font-bold tracking-[0.1em] uppercase py-1 px-2.5 rounded-full mb-3" data-id="element-53">
            BONO
          </span>
          <h3 className="font-serif text-[22px] font-semibold text-ink mb-2 leading-[1.2]" data-id="element-54">
            Guía de suplementos con evidencia
          </h3>
          <p className="text-[13px] text-ink-soft leading-[1.6]" data-id="element-55">
            Magnesio, myo-inositol, vitex, ashwagandha, omega-3 y más. Dosis
            orientativas, formas recomendadas, contraindicaciones y las "pilas"
            por perfil hormonal. +30 páginas.
          </p>
        </div>
      </Reveal>
    </section>;
}